import { SupportIcon } from '@heroicons/react/solid'
import { useTranslation } from 'react-i18next'
import { Button } from 'ui/components/Button'
import { useAnalytics } from 'utilities/analytics'

interface GuideButtonProps {
  id: string
  label?: string
  hideIcon?: boolean
  intercomArticleId?: string
  url?: string
}

export const LaunchGuideButton = (props: GuideButtonProps) => {
  const { fireEvent } = useAnalytics()
  const { t } = useTranslation()

  const handleClick = () => {
    fireEvent('launch_guide_button_clicked', {
      intercom_article_id: props.intercomArticleId,
      url: props.url,
    })

    if (props.intercomArticleId !== undefined && window.Intercom !== undefined) {
      window.Intercom('showArticle', props.intercomArticleId)
    } else {
      window.open(props.url ?? `https://help.try.be/articles/${props.intercomArticleId}`, '_blank')
    }
  }

  return (
    <Button
      id={props.id}
      leadingIcon={!props.hideIcon ? SupportIcon : null}
      variant="secondary"
      label={props.label ?? t('view_guide_button.label')}
      onClick={handleClick}
    />
  )
}
